/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Notify_DevicesInputs */

const en_notify_devices = /** @type {(inputs: Notify_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} devices signed up`)
};

const de_notify_devices = /** @type {(inputs: Notify_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Geräte angemeldet`)
};

/**
* | output |
* | --- |
* | "{count} devices signed up" |
*
* @param {Notify_DevicesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_devices = /** @type {((inputs: Notify_DevicesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_DevicesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_devices(inputs)
	return en_notify_devices(inputs)
});